import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import AuthActions from '@/actions/Auth'
import FasooNavbarConsoleComponent from '@/components/FasooConsole/Navbar'
import { getLanguage } from '@/utils/localization'

@inject('store')
@observer
export default class FasooNavbarConsoleContainer extends Component {
  constructor(props) {
    super(props)

    let path = window.location.pathname.split('/')
    let params = new URL(document.location).searchParams

    this.state = {
      product: params.has('product_admin')
        ? params.get('product_admin')
        : window.localStorage.getItem('product_admin')
        ? window.localStorage.getItem('product_admin')
        : 'Wrapsody',
      path: path[path.length - 1]
    }
  }
  handleChangeForDropdown(name, value) {
    const state = { ...this.state }
    state[name] = value
    window.localStorage.setItem('product_admin', value)
    this.setState(state)
  }

  async logout() {
    const lang = getLanguage()
    try {
      await AuthActions.logout()
      window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
    } catch (error) {
      if (error.errorCode && error.errorMessage) {
        alert(error.errorMessage)
      }
    }
  }

  goConsole() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/console`
  }

  goSite() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/site`
  }

  goLicense() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/license`
  }

  goBill() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/bill`
  }

  goCoupon() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/coupon`
  }

  goTrial() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/trial`
  }

  goNotice() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/notice`
  }

  goUser() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/user`
  }

  goAdminUser() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/adminUser`
  }

  goFasooDtoStat() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/fasooDtoStat`
  }

  goQnA() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/qna`
  }

  goUpc() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/fasoo/upc`
  }

  render() {
    const { path, product } = this.state

    return (
      <FasooNavbarConsoleComponent
        path={path}
        product={product}
        logout={this.logout.bind(this)}
        goConsole={this.goConsole}
        goSite={this.goSite}
        goLicense={this.goLicense}
        goBill={this.goBill}
        goCoupon={this.goCoupon}
        goTrial={this.goTrial}
        goNotice={this.goNotice}
        goUser={this.goUser}
        goAdminUser={this.goAdminUser}
        goFasooDtoStat={this.goFasooDtoStat}
        goQnA={this.goQnA}
        handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
        goUpc={this.goUpc}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/FasooConsole/Navbar/index.js